import "./CustomAgreement.css";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputField from "../FormParts/InputField";
import FormSubmitButton from "../FormParts/FormSubmitButton";
import FormButton from "../FormParts/FormButton";
import { sendPostRequest, getRequest, getRequestAllowAll, deleteRequest } from "../Services/ContrectBackendAPI";
import UserProfile from "../Context/UserProfile";
import { useState } from "react";
import MessageDisplay from "../CommonPages/MessageDisplay";
import InputNumberField from "../FormParts/InputNumberField";
import InputFieldBlank from "../FormParts/InputFieldBlank";
import AddAttachment from "../CommonPages/AddAttachment";
import OtherData from "../Context/OtherData";
import DeleteItemConfirmation from "../CommonPages/DeleteItemConfirmation";
import Confirmation from "../CommonPages/Confirmation";
import LoginModal from "../CommonPages/LoginModal";



const DraftContract = ({ setUserName,setPageTitle }) => {
	const termForm = useRef(null);
	const itemForm = useRef(null);
	const proposalForm = useRef(null);
	const navigate = useNavigate();
	const [msg, setMsg] = useState("");

	const [agreementObj, setAgreementObj] = useState({
          id: 0,
          contractUid: "",
          contractName: "",
          contractDescription: "",
          createdById: 0,
          sellerId: 0,
          sellerName: "",
          sellerPhoneNumber: "+910000000000",
          buyerId: 0,
          buyerName:  "",
          buyerPhoneNumber: "+910000000000",
          ldInfo:  "",
          status:  "",
          agreementAdvancePercent: 0,
          agreementSecurityAmount:  0,
          currency:  "INR",
          agreementStartDate: new Date(),
          agreementEndDate: new Date(),
          createdOn: new Date(),
          autoGenInvoice: false,
          agreementLdPercent:  0,
          agreementLdAppliedAfterDays:  0,
          agreementCompletionInDays:  0,
          agreementStatusId:  0,
          agreementSecurityReceived:false,
          agreementSecurityReturned: false,
          currencyId:  2,
          });
	const [selected, setSelected] = useState(null);
	//item section setBuyerTermList
	const [itemList, setItemList] = useState([]);
	const [itemId, setItemId] = useState();
	const [itemCurrencyOption, setItemCurrencyOption] = useState([]);
	const [itemUnitOption, setItemUnitOption] = useState([]);
	const[editedTerms,setEditTerms]=useState([0]);
	const[editedItems,setEditedItems]=useState([0]);
	const [editIndex,setEditIndex]=useState(-99);

	const [termList, setTermList] = useState([]);

	const [termId, setTermId] = useState();
	const [termTitle, setTermTitle] = useState();
	const [termText, setTermText] = useState();
	const [termAttachments, setTermAttachments] = useState([]);

	const [deleteMsg, setDeleteMsg] = useState();
	const [deleteData, setDeleteData] = useState();

	const [defaultCurreny, setDefaultCurrency] = useState(0);

	const [showItemForm,setShowItemForm]=useState(false);
	const [showTermForm,setShowTermForm]=useState(false);
	const [showAgreementForm,setShowAgreementForm]=useState(false);
	const [confirmationMsg,setConfirmationMsg]=useState(false);
	const [loginMsg,setLoginMsg]=useState("");
	const confirmationAction = useRef(() => console.log("Initial function"));

	const [remarkText,setRemarkText]=useState("");
	const [remarkAttachments,setRemarkAttachments]=useState([]);

	const[contractFlags,setContractFlags]=useState({
  agreementFlag:{
    agreementId: 0,
  contractNameBuyerFlag: false,
  contractDescriptionBuyerFlag:false,
  autoGenInvoiceBuyerFlag: false,
  ldPercentBuyerFlag:false,
  ldAppliedAfterDaysBuyerFlag:false,
  completionInDaysBuyerFlag: false,
  advancePercentBuyerFlag: false,
  securityAmountBuyerFlag: false,
  currencyIdBuyerFlag: false,

  contractNameSellerFlag: false,
  contractDescriptionSellerFlag: false,
  autoGenInvoiceSellerFlag: false,
  ldPercentSellerFlag: false,
  ldAppliedAfterDaysSellerFlag:false,
  completionInDaysSellerFlag:false,
  advancePercentSellerFlag: false,
  securityAmountSellerFlag: false,
  currencyIdSellerFlag: false,
  },
  itemFlags: [],
  termFlags: [],
  deletedTerms: [],
  deletedItems: []

});

	useEffect(() => {
		setUserName(UserProfile.getName());
		setPageTitle("Draft contract")
		if (OtherData.getData() !== "" && OtherData.getData().length > 0) {
			var obj = JSON.parse(OtherData.getData());
			console.log(obj);
			if(obj.sellerPhoneNumber===UserProfile.getPhoneNumber()){
				setSelected("Seller");
			}else{
				setSelected("Buyer");
			}
			if(obj.id>0 && !obj.generatedByAI){
				setAgreementObj(obj);
				loadItemList(obj.id);
				loadTermList(obj.id);
				getFlags(obj.id);
			}else{
				setAgreementObj(obj);
				setItemList(obj.items);
				setTermList(obj.terms);
			}
		}
		getRequestAllowAll("api/General/UnitList").then(x => x.json()).then(res => {
			if (res.status === 1) {
				setItemUnitOption(res.data);
			}
		}).catch(err => console.log(err));
		getRequestAllowAll("api/General/CurrencyList").then(x => x.json()).then(res => {
			if (res.status === 1) {
				setItemCurrencyOption(res.data);
			}
		}).catch(err => console.log(err));


	}, []);
	const loadItemList = (agreementId) => {
		getRequest("api/Business/GetAgreementItems?agreementid=" + agreementId, UserProfile.getToken()).then(x => x.json()).then(res => {
			console.log(res);
			setItemList(res.data);
		}).catch(err => console.log(err));
	}
	const loadTermList = (pid) => {
		getRequest("api/Business/AgreementTermList?agreementId=" + pid , UserProfile.getToken()).then(x => x.json()).then(res => {
			console.log(res);
			setTermList(res.data);
		}).catch(err => console.log(err));
	}
const getFlags=async(agreementId)=>{
    const token = UserProfile.getToken();
    if (!token) {
        alert('Error', 'Please login again');
        navigate("/Signup");

      return;
    }
    const res=await getRequest("api/Business/GetContractFlags?contractId="+agreementId,token);
        const resJson= await res.json();
        if (resJson.status === 1 ) {
          const flagData=
            {agreementFlag:{...resJson.agreementFlag},
            itemFlags:[],
            termFlags:[],
            deletedTerms:[],
            deletedItems:[]};
            for(let i=0;i<resJson.itemFlags.length;i++){
              flagData.itemFlags.push({...resJson.itemFlags[i]});
            }
            for(let j=0;j<resJson.termFlags.length;j++){
              flagData.termFlags.push({...resJson.termFlags[j]});
            }
            for(let k=0;k<resJson.deletedTerms.length;k++){
              flagData.deletedTerms.push({...resJson.deletedTerms[k]});
            }
            for(let l=0;l<resJson.deletedItems.length;l++){
              flagData.deletedItems.push({...resJson.deletedItems[l]});
            }
          let val1=await checkItemFlags(flagData.itemFlags);
          let val2=await checkTermFlags(flagData.termFlags);
          console.log("Value recieved- ",val1,val2);
          setContractFlags(flagData);
        }
  };
const checkItemFlags= async (itemFlags)=>{
  if(agreementObj.status==='Draft'){
    return false;
  }
  const uId = UserProfile.getUserId();
  let flag=false;
    for(let i=0;i<itemFlags.length;i++){
    if(Number(uId)===agreementObj.buyerId){
      flag=flag || itemFlags[i].taxSellerFlag===true
      || itemFlags[i].hsnCsnUinSellerFlag===true
      || itemFlags[i].descriptionSellerFlag===true
      || itemFlags[i].quantitySellerFlag===true
      || itemFlags[i].unitIdSellerFlag===true
      || itemFlags[i].rateSellerFlag===true
      || itemFlags[i].deliveredInDaysSellerFlag===true
      || itemFlags[i].titleSellerFlag===true
      || itemFlags[i].attachmentSellerFlag===true;
    }else if(Number(uId)===agreementObj.sellerId){
      flag=flag || itemFlags[i].taxBuyerFlag===true
      || itemFlags[i].hsnCsnUinBuyerFlag===true
      || itemFlags[i].descriptionBuyerFlag===true
      || itemFlags[i].quantityBuyerFlag===true
      || itemFlags[i].unitIdBuyerFlag===true
      || itemFlags[i].rateBuyerFlag===true
      || itemFlags[i].deliveredInDaysBuyerFlag===true
      || itemFlags[i].titleBuyerFlag===true
      || itemFlags[i].attachmentBuyerFlag===true;
    }
  }
  //setErrorItem(flag);
  return flag;

};
const checkTermFlags= async(termFlags)=>{
  if(agreementObj.status==='Draft'){
    return false;
  }
  const uId = UserProfile.getUserId();
  let flag=false;
  for(let i=0;i<termFlags.length;i++){
    if(Number(uId)===agreementObj.buyerId){
      flag=flag || termFlags[i].termTextSellerFlag
      || termFlags[i].titleSellerFlag
      || termFlags[i].attachmentSellerFlag;
    }else if(Number(uId)===agreementObj.sellerId){
      flag=flag || termFlags[i].termTextBuyerFlag
      || termFlags[i].titleBuyerFlag
      || termFlags[i].attachmentBuyerFlag;
    }
  }
  //setErrorTerm(flag);
  return flag;
}; 
const handleSendForReview = async () => {
    // if (!validateContractForm()) {
    //   Alert.alert('Validation Error', 'Please fix the errors before submitting');
    //   setLoading(false);
    //   return;
    // }

    const t = UserProfile.getToken();
    const usrId = UserProfile.getUserId();

    if (agreementObj.id<=0 && t && usrId) {
      const formBody = {
        Id: 0,
        ContractName: agreementObj.contractName,
        AgreementLdAppliedAfterDays: agreementObj.agreementLdAppliedAfterDays,
        
        AgreementLdPercent: agreementObj.agreementLdPercent,
        AgreementAdvancePercent: agreementObj.agreementAdvancePercent,
        AgreementCompletionInDays: agreementObj.agreementCompletionInDays,

        ContractUid:agreementObj.contractUid,
        SellerId:agreementObj.sellerId,
        SellerPhoneNumber:agreementObj.sellerPhoneNumber,
        
        BuyerId:agreementObj.buyerId,
        BuyerPhoneNumber:agreementObj.buyerPhoneNumber,
        ContractDescription: agreementObj.contractDescription,
        
        CreatedById: Number(usrId),
        Status:'',
        Currency:'',
        
        CurrencyId: defaultCurreny && defaultCurreny>0?defaultCurreny:1,
        AgreementSecurityAmount: agreementObj.agreementSecurityAmount,
        AgreementStatusId:  agreementObj.agreementStatusId,
        
        AgreementSecurityReceived:false,
        AgreementSecurityReturned:false,
        AgreementStartDate: agreementObj.agreementStartDate,
        
        AgreementEndDate: agreementObj.agreementEndDate,
        autoGenInvoice: agreementObj.autoGenInvoice,
        CreatedOn: agreementObj.createdOn,
        
        SellerName: "",
        BuyerName: ""
      };

      try {
        const res = await sendPostRequest('api/Business/AddContract', t, formBody);
        const resJson = await res.json();

        if (resJson.status === 1) {
          const promises = [];

          if (t) {
            for (let i = 0; i < itemList.length; i++) {

              const itemForm = {
                Id: 0,
                AgreementId: resJson.data.id,
                CreatorId: Number(usrId),
                ItemRate: itemList[i].itemRate,
                ItemTax: itemList[i].itemTax,
                ItemTitle: itemList[i].itemTitle,
                ItemDescription: itemList[i].itemDescription,
                ItemHsnSac: itemList[i].itemHsnSac,
                ItemDeliveredInDays: itemList[i].itemDeliveredInDays,
                ItemQuantity: itemList[i].itemQuantity,
                CurrencyId: defaultCurreny && defaultCurreny>0?defaultCurreny:1,
                ItemUnitId: itemList[i].itemUnitId,
                UnitName: itemList[i].unitName,
                ItemAttachments: itemList[i].itemAttachments.map((att) => ({
                  Id: att.id,
                  Name: att.name,
                  Link: att.link,
                })) ,
                CreatedOn: new Date()
              };

              const p1 = sendPostRequest('api/Business/AddAgreementItem', t, itemForm)
                .then((r) => r.json())
                .then((resI) => {
                  if (resI.status !== 1) {
                    alert('Some error while adding item ' + itemList[i].itemTitle);
                  }
                })
                .catch((err) => console.log(err));
              promises.push(p1);
            }

            for (let j = 0; j < termList.length; j++) {
              const termForm = {
                Id: 0,
                IsDeleted: false,
                TermTitle: termList[j].termTitle,
                TermTxt: termList[j].termTxt,
                AgreementId: resJson.data.id,
                TermAttachments: termList[j].termAttachments,
              };

              const p2 = sendPostRequest('api/Business/AddAgreementTerm', t, termForm)
                .then((r) => r.json())
                .then((rest) => {
                  if (rest.status !== 1) {
                    alert('Some error while adding term ' + termList[j].termTitle);
                  }
                })
                .catch((err) => console.log(err));
              promises.push(p2);
            }

            const results = await Promise.all(promises);

            if (results.length === itemList.length + termList.length) {
              const startResp = await sendPostRequest(`api/Business/PublishAgreement`, t,{
                Id:0,
                ParentId:resJson.data.id,
                RemarkText:remarkText,
                OwnerId:Number(usrId),
                OwnerName:UserProfile.getName(),
                CreatedOn:new Date(),
                Attachments:remarkAttachments
              });
              const startJson = await startResp.json();
              if (startJson.status === 1) {
                const tempAgreement = agreementObj;
                tempAgreement.id = resJson.data.id;
                alert('Success', 'Agreement is sent for review successfully');
                navigate('/home');
              }else{
                alert('Failed', 'Not able to start agreement');
              }
            }
          }
          //await notify(creator.userId=== agreementData.buyerId ? agreementData.sellerId:agreementData.buyerId,"Agreement under review","New agreement is sent for your review.");
        }
      } catch (err) {
        console.log(err);
      }finally{
        //setLoading(false);
      }
    } else if (agreementObj.id>0 && t && usrId) {
      const formBody = {
        Id: agreementObj.id,
        ContractName: agreementObj.contractName,
        AgreementLdAppliedAfterDays: agreementObj.agreementLdAppliedAfterDays,
        
        AgreementLdPercent: agreementObj.agreementLdPercent,
        AgreementAdvancePercent: agreementObj.agreementAdvancePercent,
        AgreementCompletionInDays: agreementObj.agreementCompletionInDays,

        ContractUid:agreementObj.contractUid,
        SellerId:agreementObj.sellerId,
        SellerPhoneNumber:agreementObj.sellerPhoneNumber,
        
        BuyerId:agreementObj.buyerId,
        BuyerPhoneNumber:agreementObj.buyerPhoneNumber,
        ContractDescription: agreementObj.contractDescription,
        
        CreatedById: Number(usrId),
        Status:'',
        Currency:'',
        
        CurrencyId: defaultCurreny && defaultCurreny>0?defaultCurreny:1,
        AgreementSecurityAmount: agreementObj.agreementSecurityAmount,
        AgreementStatusId:  agreementObj.agreementStatusId,
        
        AgreementSecurityReceived:false,
        AgreementSecurityReturned:false,
        AgreementStartDate: agreementObj.agreementStartDate,
        
        AgreementEndDate: agreementObj.agreementEndDate,
        autoGenInvoice: agreementObj.autoGenInvoice,
        CreatedOn: agreementObj.createdOn,
        
        SellerName: "",
        BuyerName: ""
      };

      try {
        const res = await sendPostRequest('api/Business/UpdateAgreement', t, formBody);
        const resJson = await res.json();
        // console.log("Update contract response-",JSON.stringify(resJson));
        if (resJson.status === 1 && t) {
          for(let i=0;i<editedItems.length;i++){
            const items=itemList.filter(x=>x.id===editedItems[i]);
            for(let x=0;x<items.length;x++){

              const itemForm = {
                Id: items[x].id,
                AgreementId: agreementObj.id,
                CreatorId: Number(usrId),
                ItemRate: items[x].itemRate,
                ItemTax: items[x].itemTax,
                ItemTitle: items[x].itemTitle,
                ItemDescription: items[x].itemDescription,
                ItemHsnSac: items[x].itemHsnSac,
                ItemDeliveredInDays: items[x].itemDeliveredInDays,
                ItemQuantity: items[x].itemQuantity,
                CurrencyId: defaultCurreny && defaultCurreny>0?defaultCurreny:1,
                ItemUnitId: items[x].itemUnitId,
                UnitName: items[x].unitName,
                ItemAttachments: items[x].itemAttachments.map((att) => ({
                  Id: att.id,
                  Name: att.name,
                  Link: att.link,
                })) ,
                CreatedOn: new Date()
              };

              const p1 = await sendPostRequest('api/Business/AddAgreementItem', t, itemForm);
              const p1Json=await p1.json();
              // console.log("item"+i+1+" added-",p1Json);
              if(p1Json.status!==1)
              {
                alert('Some error while adding item ' + items[x].itemTitle);
              }
            }
          } 

          for(let i=0;i<editedTerms.length;i++){
            const terms=termList.filter(x=>x.id===editedTerms[i]);
            for(let x=0;x<terms.length;x++){
              const termForm = {
                Id: terms[x].id,
                TermTitle: terms[x].termTitle,
                TermTxt: terms[x].termTxt,
                AgreementId: agreementObj.id,
                TermAttachments: terms[x].termAttachments.map((att) => ({
                  Id: att.id,
                  Name: att.name,
                  Link: att.link,
                })) ,
                IsDeleted:false
              };

              const p2 = await sendPostRequest('api/Business/AddAgreementTerm', t, termForm);
              const p2Json=await p2.json();
              // console.log("term"+j+1+" added-",p2Json);
              if(p2Json.status!==1)
              {
                alert('Some error while adding term ' + terms[x].termTitle);
              }
            }
          } 
          const startResp = await sendPostRequest(`api/Business/PublishAgreement`, t,{
            Id:0,
            ParentId:resJson.id,
            RemarkText:remarkText,
            OwnerId:Number(usrId),
            OwnerName:UserProfile.getName(),
            CreatedOn:new Date(),
            Attachments:remarkAttachments
          });
          const startJson = await startResp.json();

          if (startJson.status === 1) {

            const tempAgreement = agreementObj;
            tempAgreement.id = resJson.id;
            alert('Success', 'Agreement is sent for review successfully');
            navigate('/home');
          }
        } else {
          alert('Failed', 'Not able to send contract for review');
        }
      } catch (err) {
        console.log(err);
      }finally{
        //setLoading(false);
      }
    } else {
      //setLoading(false);
      UserProfile.resetUser();
	  OtherData.resetData();
      navigate('/Signup');
    }
    
  };
	const handleSubmit = (e) => {
		e.preventDefault();
		
		setAgreementObj({...agreementObj,
			contractName:proposalForm.current['ContractName'].value,
			contractDescription:proposalForm.current['Description'].value,
			agreementAdvancePercent:proposalForm.current['Advance'].value,
			agreementSecurityAmount:proposalForm.current['Deposite'].value,
			autoGenInvoice:proposalForm.current['AutoGen'].checked,
			agreementLdPercent:proposalForm.current['LDPercent'].value,
			agreementLdAppliedAfterDays:proposalForm.current['LDDays'].value,
			agreementCompletionInDays:proposalForm.current['NumberOfDays'].value,
			currencyId:defaultCurreny>0?defaultCurreny:2,
			sellerPhoneNumber:selected==="Seller"?UserProfile.getPhoneNumber():proposalForm.current['OtherPartyContact'].value,
			buyerPhoneNumber:selected==="Buyer"?UserProfile.getPhoneNumber():proposalForm.current['OtherPartyContact'].value,
			sellerId:selected==="Seller"?Number(UserProfile.getUserId()):0,
			BuyerId:selected==="Buyer"?Number(UserProfile.getUserId()):0
		});
		setShowAgreementForm(false);

	};


	const handleSaveDraft = async () => {
    // setLoading(true);
    // if (!validateContractForm()) {
    //   Alert.alert('Validation Error', 'Please fix the errors before submitting');
    //   setLoading(false);
    //   return;
    // }
    
    const t = UserProfile.getToken();
    const usrId = UserProfile.getUserId();

    if (agreementObj.id<=0 && t && usrId) {

      const formBody = {
        Id: 0,
        ContractUid: '',
        CreatedById: Number(usrId),
        SellerId:selected==="Seller"?Number(usrId):agreementObj.sellerId,
        
        BuyerId: selected==="Buyer"?Number(usrId):agreementObj.buyerId,
        SellerPhoneNumber:selected==="Seller"?UserProfile.getPhoneNumber():agreementObj.sellerPhoneNumber,
        BuyerPhoneNumber: selected==="Buyer"?UserProfile.getPhoneNumber():agreementObj.buyerPhoneNumber,
        SellerName:"",
        
        BuyerName: "",
        Status:"",
        AutoGenInvoice:agreementObj.autoGenInvoice,
        AgreementSecurityReceived:false,
        
        AgreementSecurityReturned:false,
        CurrencyId: 2,
        Currency: "",
        AgreementStatusId:1,
        
        AgreementStartDate: new Date(),
        AgreementEndDate: new Date(),
        CreatedOn: new Date(),
        AgreementLdAppliedAfterDays: agreementObj.agreementLdAppliedAfterDays,
        
        AgreementLdPercent: agreementObj.agreementLdPercent,
        AgreementAdvancePercent: agreementObj.agreementAdvancePercent,
        AgreementCompletionInDays: agreementObj.agreementCompletionInDays,
        AgreementSecurityAmount: agreementObj.agreementSecurityAmount,
        
        ContractName: agreementObj.contractName,
        ContractDescription:agreementObj.contractDescription
      };

      try {
        const res = await sendPostRequest('api/Business/AddContract', t, formBody);
        const resJson = await res.json();

        if (resJson.status === 1) {
          if (t) {
            for (let i = 0; i < itemList.length; i++) {

              const itemForm = {
                Id: 0,
                AgreementId: resJson.data.id,
                CreatorId: Number(UserProfile.getUserId()),
                ItemRate: itemList[i].itemRate,
                ItemTax: itemList[i].itemTax,
                ItemTitle: itemList[i].itemTitle,
                ItemDescription: itemList[i].itemDescription,
                ItemHsnSac: itemList[i].itemHsnSac,
                ItemDeliveredInDays: itemList[i].itemDeliveredInDays,
                ItemQuantity: itemList[i].itemQuantity,
                CurrencyId: 2,
                ItemUnitId: itemList[i].itemUnitId,
                UnitName: itemList[i].unitName,
                ItemAttachments: itemList[i].itemAttachments.map((att) => ({
                  Id: att.id,
                  Name: att.name,
                  Link: att.link,
                })) ,
                CreatedOn: new Date()
              };

              const p1 = await sendPostRequest('api/Business/AddAgreementItem', t, itemForm);
              const p1Json=await p1.json();
              // console.log("item"+i+1+" added-",p1Json);
              if(p1Json.status!==1)
              {
                alert('Some error while adding item ' + itemList[i].itemTitle);
              }
            }

            for (let j = 0; j < termList.length; j++) {
              const termForm = {
                Id: 0,
                TermTitle: termList[j].termTitle,
                TermTxt: termList[j].termTxt,
                AgreementId: resJson.data.id,
                TermAttachments: termList[j].termAttachments.map((att) => ({
                  Id: att.id,
                  Name: att.name,
                  Link: att.link,
                })) ,
                IsDeleted:false
              };

              const p2 = await sendPostRequest('api/Business/AddAgreementTerm', t, termForm);
              const p2Json=await p2.json();
              // console.log("term"+j+1+" added-",p2Json);
              if(p2Json.status!==1)
              {
                alert('Some error while adding term ' + termList[j].termTitle);
              }
            }

          }
		      navigate('/Home');
        }else{
          alert('Failed', 'Not able to save data '+JSON.stringify(resJson));
        }
      } catch (err) {
        console.log(err);
      } finally{
        //setLoading(false);
      }
    } else if (agreementObj.id>0 && t && usrId) {
      const formBody = {
        Id: agreementObj.id,
        ContractName: agreementObj.contractName,
        AgreementLdAppliedAfterDays: agreementObj.agreementLdAppliedAfterDays,
        
        AgreementLdPercent: agreementObj.agreementLdPercent,
        AgreementAdvancePercent: agreementObj.agreementAdvancePercent,
        AgreementCompletionInDays: agreementObj.agreementCompletionInDays,

        ContractUid:agreementObj.contractUid,
        SellerId:agreementObj.sellerId,
        SellerPhoneNumber:agreementObj.sellerPhoneNumber,
        
        BuyerId:agreementObj.buyerId,
        BuyerPhoneNumber:agreementObj.buyerPhoneNumber,
        ContractDescription: agreementObj.contractDescription,
        
        CreatedById: Number(UserProfile.getUserId()),
        Status:'',
        Currency:'',
        
        CurrencyId: 2,
        AgreementSecurityAmount: agreementObj.agreementSecurityAmount,
        AgreementStatusId:  agreementObj.agreementStatusId,
        
        AgreementSecurityReceived:false,
        AgreementSecurityReturned:false,
        AgreementStartDate: agreementObj.agreementStartDate,
        
        AgreementEndDate: agreementObj.agreementEndDate,
        autoGenInvoice: agreementObj.autoGenInvoice,
        CreatedOn: agreementObj.createdOn,
        
        SellerName: "",
        BuyerName: ""
      };

      try {
        const res = await sendPostRequest('api/Business/UpdateAgreement', t, formBody);
        const resJson = await res.json();
        console.log(JSON.stringify(editedItems));
        if (resJson.status === 1) {
          for(let i=0;i<editedItems.length;i++){
            const items=itemList.filter(x=>x.id===editedItems[i]);
            for(let x=0;x<items.length;x++){
              console.log(x,i,"adding items");
              const itemForm = {
                Id: items[x].id,
                AgreementId: agreementObj.id,
                CreatorId: Number(UserProfile.getUserId()),
                ItemRate: items[x].itemRate,
                ItemTax: items[x].itemTax,
                ItemTitle: items[x].itemTitle,
                ItemDescription: items[x].itemDescription,
                ItemHsnSac: items[x].itemHsnSac,
                ItemDeliveredInDays: items[x].itemDeliveredInDays,
                ItemQuantity: items[x].itemQuantity,
                CurrencyId: 2,
                ItemUnitId: items[x].itemUnitId,
                UnitName: items[x].unitName,
                ItemAttachments: items[x].itemAttachments.map((att) => ({
                  Id: att.id,
                  Name: att.name,
                  Link: att.link,
                })) ,
                CreatedOn: new Date()
              };

              const p1 = await sendPostRequest('api/Business/AddAgreementItem', t, itemForm);
              const p1Json=await p1.json();
              // console.log("item"+i+1+" added-",p1Json);
              if(p1Json.status!==1)
              {
                alert('Some error while adding item ' + items[x].itemTitle);
              }
            }
          } 

          for(let i=0;i<editedTerms.length;i++){
            const terms=termList.filter(x=>x.id===editedTerms[i]);
            for(let x=0;x<terms.length;x++){
              console.log(x,i,"adding Terms");
              const termForm = {
                Id: terms[x].id,
                TermTitle: terms[x].termTitle,
                TermTxt: terms[x].termTxt,
                AgreementId: agreementObj.id,
                TermAttachments: terms[x].termAttachments.map((att) => ({
                  Id: att.id,
                  Name: att.name,
                  Link: att.link,
                })) ,
                IsDeleted:false
              };

              const p2 = await sendPostRequest('api/Business/AddAgreementTerm', t, termForm);
              const p2Json=await p2.json();
              // console.log("term"+j+1+" added-",p2Json);
              if(p2Json.status!==1)
              {
                alert('Some error while adding term ' + terms[x].termTitle);
              }
            }
          } 


          navigate('/Home');
          
        } else {
          alert('Failed', 'Not able to save data');
        }
      } catch (err) {
        console.log(err);
      }finally{
        //setLoading(false);
      }
    } else {
      //setLoading(false);
    //   await AsyncStorage.clear();
	UserProfile.resetUser();
	OtherData.resetData();
      navigate('/Signup');
    }
  };




	const handleSubmitAddItem = (e) => {
		e.preventDefault();
		if(!editedItems.find(x=>x===editIndex) && editIndex!==-99){
			const newEditedItem=[...editedItems];
			console.log(newEditedItem);
			newEditedItem.push(editIndex);
			setEditedItems(newEditedItem);
		}
		
		var postBody = {

			id: itemId > 0 ? itemId : 0,
			agreementId: agreementObj.id,
			itemTax: itemForm.current["Tax"] ? itemForm.current["Tax"].value:0,
			itemHsnSac: itemForm.current["ItemCode"].value,
			itemTitle: itemForm.current["ItemTitle"].value,
			itemDescription: itemForm.current["ItemDescription"].value,
			itemQuantity: itemForm.current["Qty"].value,
			itemUnitId: itemForm.current["UnitId"] ? itemForm.current["UnitId"].value:1,
			unitName: "",
			itemRate: itemForm.current["Rate"] ? itemForm.current["Rate"].value:0,
			itemDeliveredInDays: itemForm.current["ItemDeliveredInDays"] ? itemForm.current["ItemDeliveredInDays"].value:0,
			itemAttachments:[],
			createdOn: new Date()

		};
		if(editIndex>-1){
			const newItemList=[...itemList];
			newItemList[editIndex]=postBody;
			setItemList(newItemList);
		}else{
			setItemList(pre=>[...pre,postBody]);
		}
		console.log(postBody);
		setEditIndex(-99);
		resetItemForm();
		setShowItemForm(false);
	}
	const resetItemForm = () => {
		setItemId(0);
		itemForm.current["Rate"].value = 0;
		itemForm.current["Tax"].value =0;
		itemForm.current["Qty"].value =0;
		itemForm.current["ItemTitle"].value ='';
		itemForm.current["ItemDescription"].value ='';
		itemForm.current["ItemCode"].value ='';
		itemForm.current["ItemDeliveredInDays"].value =agreementObj.agreementCompletionInDays;
		itemForm.current["UnitId"].value =0;
		setTermAttachments([]);
	}
	const resetTermForm = () => {
		setTermId(0);
		setTermText("");
		setTermTitle("")
		termForm.current['TermTitle'].value = "";
		termForm.current['TermTxt'].value = "";
		setTermAttachments([]);
	}
	const handleSubmitAddTerm = (e) => {
		e.preventDefault();
		if(!editedTerms.find(x=>x===editIndex) && editIndex!==-99){
			const newEditedTerm=[...editedTerms];
			console.log(newEditedTerm);
			newEditedTerm.push(editIndex);
			setEditTerms(newEditedTerm);
		}
		
		var postBody = {
			id: termId && termId > 0 ? termId : 0,
			termTitle: termForm.current['TermTitle'].value,
			termTxt: termForm.current['TermTxt'].value,
			agreementId: agreementObj.id,
			termAttachments:termAttachments,
			isDeleted: false
		};
		if(editIndex>-1){
			const newTermList=[...termList];
			newTermList[editIndex]=postBody;
			setTermList(newTermList);
		}else{
			setTermList([...termList,postBody]);
		}
		setEditIndex(-99);
		console.log(postBody);
		resetTermForm();
		setShowTermForm(false);
	};

	const startContract = () => {
		getRequest("api/Business/StartAgreement?agreementId=" + agreementObj.id, UserProfile.getToken())
			.then(x => x.json())
			.then(res => {
				console.log(res);
				if (res.status === 1) {
					agreementObj.items=itemList;
					agreementObj.terms=termList;
					OtherData.setData(JSON.stringify(agreementObj));
					navigate("/DetailAgreement");
				}
			}).catch(err => console.log(err));
	}
	const editTerms = (e, term,index) => {
		e.preventDefault();
		setShowTermForm(true);
		console.log(term);
		setTermId(term.id);
		setEditIndex(index);
		setTermTitle(term.termTitle);
		setTermText(term.termTxt);
		termForm.current['TermTitle'].value = term.termTitle;
		termForm.current['TermTxt'].value = term.termTxt;
	}
	const deleteAction = (url) => {
		deleteRequest(url, UserProfile.getToken()).then(x => x.json()).then(res => {
			setMsg("Deleted successfully");
			loadItemList(agreementObj.id);
			loadTermList(agreementObj.id);
		}).catch(err => console.log(err));
	}
	const editOrAddRate = (e, item,index) => {
		e.preventDefault();
		setShowItemForm(true);
		console.log(item);
		setItemId(item.id);
		setEditIndex(index);
		itemForm.current["Rate"].value = item.itemRate;
		itemForm.current["Tax"].value = item.itemTax;
		itemForm.current["Qty"].value = item.itemQuantity;
		itemForm.current["ItemTitle"].value = item.itemTitle;
		itemForm.current["ItemDescription"].value = item.itemDescription;
		itemForm.current["ItemCode"].value = item.itemHsnSac;
		itemForm.current["ItemDeliveredInDays"].value = item.itemDeliveredInDays;
		itemForm.current["UnitId"].value = item.unit;

	}
	const openTab = (e, id) => {
		e.preventDefault();
		var tabContent = document.getElementsByClassName("tab-content");
		for (var i = 0; i < tabContent.length; i++) {
			tabContent[i].style.display = "none";
			tabContent[i].classList.remove("active");
		}
		var tabButtons = document.getElementsByClassName("tab-button");
		for (var i = 0; i < tabButtons.length; i++) {
			tabButtons[i].classList.remove("active");
		}
		document.getElementById(id).style.display = "block";
		document.getElementById(id).classList.add("active");
		e.currentTarget.classList.add("active");
	}
	const formatINRCurrency = (value) =>
    new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 2,
    }).format(value);

const checkStartAllowed=()=>{
  let flag=false;
  if(contractFlags){
    flag= flag || contractFlags.agreementFlag.advancePercentBuyerFlag 
    || contractFlags.agreementFlag.autoGenInvoiceBuyerFlag
    || contractFlags.agreementFlag.completionInDaysBuyerFlag 
    || contractFlags.agreementFlag.contractDescriptionBuyerFlag 
    || contractFlags.agreementFlag.contractNameBuyerFlag 
    || contractFlags.agreementFlag.currencyIdBuyerFlag
    || contractFlags.agreementFlag.ldAppliedAfterDaysBuyerFlag
    || contractFlags.agreementFlag.ldPercentBuyerFlag
    || contractFlags.agreementFlag.securityAmountBuyerFlag;
    for(let i=0;i<contractFlags.itemFlags.length;i++){
      flag= flag || contractFlags.itemFlags[i].attachmentBuyerFlag
      || contractFlags.itemFlags[i].deliveredInDaysBuyerFlag
      || contractFlags.itemFlags[i].descriptionBuyerFlag
      || contractFlags.itemFlags[i].hsnCsnUinBuyerFlag
      || contractFlags.itemFlags[i].quantityBuyerFlag
      || contractFlags.itemFlags[i].rateBuyerFlag
      || contractFlags.itemFlags[i].taxBuyerFlag
      || contractFlags.itemFlags[i].titleBuyerFlag
      || contractFlags.itemFlags[i].unitIdBuyerFlag;
    }
    for(let j=0;j< contractFlags.termFlags.length;j++){
      flag=flag || contractFlags.termFlags[j].attachmentBuyerFlag
      ||contractFlags.termFlags[j].termTextBuyerFlag
      || contractFlags.termFlags[j].titleBuyerFlag;
    }
    return flag;   
  }
};
  const checkGeneralInfo=()=>{
    // if(contractErrors.advance){
    //     return true;
    // }
    // if(contractErrors.contractDuration){
    //     return true;
    // }
    // if(contractErrors.contractName){
    //     return true;
    // }
    // if(contractErrors.deposite){
    //     return true;
    // }
    // if(contractErrors.description){
    //     return true;
    // }
    // if(contractErrors.ldDays){
    //     return true;
    // }
    // if(contractErrors.ldPercent){
    //     return true;
    // }
    if(contractFlags && contractFlags.agreementFlag){
      if(Number(UserProfile.getUserId())===agreementObj.sellerId){
        if(contractFlags.agreementFlag.advancePercentBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.autoGenInvoiceBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.completionInDaysBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.contractDescriptionBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.contractNameBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.currencyIdBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.ldAppliedAfterDaysBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.ldPercentBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.securityAmountBuyerFlag){
          return true;
        }
      }
      else if(Number(UserProfile.getUserId())===agreementObj.buyerId){
        
        if(contractFlags.agreementFlag.autoGenInvoiceSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.completionInDaysSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.contractDescriptionSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.contractNameSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.currencyIdSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.ldAppliedAfterDaysSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.ldPercentSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.securityAmountSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.advancePercentSellerFlag){
          return true;
        }
      }
    }
    return false;
};
const checkAdditionalInfo=()=>{
    // if(contractErrors.advance){
    //     return true;
    // }

    // if(contractErrors.deposite){
    //     return true;
    // }
    // if(contractErrors.ldDays){
    //     return true;
    // }
    // if(contractErrors.ldPercent){
    //     return true;
    // }
    if(contractFlags && contractFlags.agreementFlag){
      if(Number(UserProfile.getUserId())===agreementObj.sellerId){
        if(contractFlags.agreementFlag.advancePercentBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.ldAppliedAfterDaysBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.ldPercentBuyerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.securityAmountBuyerFlag){
          return true;
        }
      }
      else if(Number(UserProfile.getUserId())===agreementObj.buyerId){
        
        if(contractFlags.agreementFlag.ldAppliedAfterDaysSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.ldPercentSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.securityAmountSellerFlag){
          return true;
        }
        if(contractFlags.agreementFlag.advancePercentSellerFlag){
          return true;
        }
      }
    }
    return false;
};
  const IsItemEdited = (item) => {
      if(agreementObj.status.toLocaleLowerCase()==="draft")
      {
        return false;
      }
      const tempItemFlag=contractFlags?contractFlags.itemFlags.find((itf)=>itf.itemId===item.id):undefined;
      if(!tempItemFlag){
        return false;
      }
      // console.log("Item Flag found for item id "+item.id+": "+JSON.stringify(tempItemFlag));
      if(tempItemFlag && Number(UserProfile.getUserId())===agreementObj.buyerId){
        return tempItemFlag.attachmentSellerFlag||tempItemFlag.descriptionSellerFlag||
        tempItemFlag.quantitySellerFlag||tempItemFlag.rateSellerFlag||
        tempItemFlag.taxSellerFlag ||tempItemFlag.titleSellerFlag ||
        tempItemFlag.hsnCsnUinSellerFlag||tempItemFlag.unitIdSellerFlag||tempItemFlag.deliveredInDaysSellerFlag;
      }
      if(tempItemFlag && Number(UserProfile.getUserId())===agreementObj.sellerId){
        return tempItemFlag.attachmentBuyerFlag||tempItemFlag.descriptionBuyerFlag||
        tempItemFlag.quantityBuyerFlag||tempItemFlag.rateBuyerFlag||
        tempItemFlag.taxBuyerFlag||tempItemFlag.titleBuyerFlag ||
        tempItemFlag.hsnCsnUinBuyerFlag||tempItemFlag.unitIdBuyerFlag||tempItemFlag.deliveredInDaysBuyerFlag;
      }
      return false;
    };
const IsTermEdited = (item) => {
      if(agreementObj.status.toLocaleLowerCase()==="draft")
      {
        return false;
      }
      const tempTermFlag=contractFlags?.termFlags.find((itf)=>itf.termId===item.id);
      if(!tempTermFlag){
        return false;
      }
      if(tempTermFlag && Number(UserProfile.getUserId())===agreementObj.buyerId){
        return tempTermFlag.attachmentSellerFlag||tempTermFlag.titleSellerFlag||
        tempTermFlag.termTextSellerFlag;
      }
      if(tempTermFlag && Number(UserProfile.getUserId())===agreementObj.sellerId){
        return tempTermFlag.attachmentBuyerFlag||tempTermFlag.termTextBuyerFlag||
        tempTermFlag.titleBuyerFlag;
      }
      return false;
    };
const IsAgreementFieldChanged= (fieldName)=>{
    if(agreementObj.status.toLocaleLowerCase()==="draft")
    {
      return false;
    }
    return contractFlags?.agreementFlag?.[fieldName] === true
  };
const IsItemFieldChanged= (fieldName,itemId)=>{
    if(agreementObj.status.toLocaleLowerCase()==="draft")
    {
      return false;
    }
    const tempItemFlag=contractFlags?.itemFlags.find((itf)=>itf.itemId===itemId);
    if(!tempItemFlag){
      return false;
    }
    return tempItemFlag[fieldName]===true;
  };
const IsTermFieldChanged= (fieldName,termId)=>{
    if(agreementObj.status.toLocaleLowerCase()==="draft")
    {
      return false;
    }
    const tempTermFlag=contractFlags?.termFlags.find((itf)=>itf.termId===termId);
    if(!tempTermFlag){
      return false;
    }
    return tempTermFlag[fieldName]===true;
  };

	return (<>
		<div className="main-content" style={{padding:'20px'}}>
			<MessageDisplay msg={msg} setMsg={setMsg} />
			<DeleteItemConfirmation msg={deleteMsg} setMsg={setDeleteMsg} action={deleteAction} data={deleteData} />
			<Confirmation msg={confirmationMsg} setMsg={setConfirmationMsg} action={confirmationAction }/>
			<LoginModal msg={loginMsg} setMsg={setLoginMsg}/>
			{agreementObj ?
				<div>
					<div className="table">
						<div className="row">
							<div className="col-md-1" style={{ textAlign: "left" }}>
								<FormButton name="Back" onClick={(e) => {
									e.preventDefault();
									setConfirmationMsg("Are you sure you want to go back to dashboard? Your changes will not be saved.");
									confirmationAction.current=()=>{ 
										navigate("/home");
										confirmationAction.current=()=>{console.log("Going back to home page");};
									};
								}} />
							</div>
							<div className="col-md-3">
								<FormButton name="Save as draft" onClick={(e) => {
									e.preventDefault();
									if(UserProfile.getLoginStatus()!=="1"){
										setLoginMsg("Please login to save the contract.");
									}else{
										handleSaveDraft();
									}
									
								}} />
							</div>
							{agreementObj.status.toLocaleLowerCase()==="waiting for buyer" 
							&& agreementObj.buyerId===Number(UserProfile.getUserId() && !checkStartAllowed() && <div className="col-md-4">
								<FormButton name="Start" onClick={(e) => {
									e.preventDefault();
									setConfirmationMsg("Are you sure you want to go back to start the contract?"+
										" If you have done anye new changes, your changes will not be saved.");
									confirmationAction.current=()=>{ 
										startContract();
										confirmationAction.current=()=>{console.log("Going detail page.")};
									};
									
								}} />
							</div>)}
							
							<div className="col-md-4">
								<FormButton name="Send for review" onClick={(e) => {
									e.preventDefault();
									if(UserProfile.getLoginStatus()!=="1"){
										setLoginMsg("Please login to send the contract to other party.")
									}else{
										handleSendForReview();
									}
									
								}} />
							</div>
						</div>
						<div className="row" style={{ border: "solid 1px #0F172A" }}>
						</div>
						<div style={{margin:'10px',border:'solid 2px #0F172A', borderRadius:'10px',padding:"10px"}}>
							<Form ref={proposalForm} onSubmit={handleSubmit}>
							{showAgreementForm===true 
							?<div className="row" style={{ padding:"5px" }}>
								{agreementObj.status===""?<>
								<div className="col-md-6">
									<div class="radio-group">
									<label class="radio-label">
										<input 
										type="radio" 
										name="userType" 
										value="Seller" 
										checked={selected === 'Seller'}
										onClick={(e)=>{
	
											setSelected('Seller')}}
										/>
										<span class="radio-custom"></span>
										<span class="value-text">Seller(Party that recieves pay)</span>
									</label>

									<label class="radio-label">
										<input 
										type="radio" 
										name="userType" 
										value="Buyer" 
										checked={selected === 'Buyer'}
										onClick={(e)=>{
		
											setSelected('Buyer');}}
										/>
										<span class="radio-custom"></span>
										<span class="value-text">Buyer(Party that pays)</span>
									</label>
									</div>
								</div>
								<div className="col-md-6">
								{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"contractNameBuyerFlag":"contractNameSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="OtherPartyContact" type="text" label="Other party contact" 
									value={selected==="Seller"?agreementObj.buyerPhoneNumber:agreementObj.sellerPhoneNumber} />
								</div>
								</>:<>
								<div className="row">
									<div className="col-md-6"> Your role: {selected}</div>
									<div className="col-md-6"> Other party contact number: {
									selected==="Seller"?agreementObj.sellerPhoneNumber:agreementObj.buyerPhoneNumber} </div>
								</div>
								</>}
								
								<div className="col-md-3">
									{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"currencyIdBuyerFlag":"currencyIdSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									
										<span className="" style={{ textAlign: 'left' }}>
											<label style={{ fontsize: '20px', color: 'black', fontWeight: '700' }} >Currency</label>
											<select name="CurrencyId" className="myAginput"
												onChange={(e) => {
													e.preventDefault();
													setDefaultCurrency(e.target.value);
													//setItemRateCurrency(e.target.value);
												}}>
												<option value="-99" selected >-Select-</option>
												{itemCurrencyOption && itemCurrencyOption.length > 0 ?
													itemCurrencyOption.map(x => <option value={x.id} >{x.typeValue}</option>) :
													<></>}
											</select>
										</span>
									</div>
								<div className="col-md-3">
								{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"contractNameBuyerFlag":"contractNameSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="ContractName" type="text" label="Contract Name" value={agreementObj.contractName} />
								</div>
								<div className="col-md-3">
									{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"contractDescriptionBuyerFlag":"contractDescriptionSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="Description" type="text" label="Description" value={agreementObj.contractDescription} />
								</div>
								<div className="col-md-3">
									{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"advancePercentBuyerFlag":"advancePercentSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="Advance" type="number" label="Advance (%)" value={agreementObj.agreementAdvancePercent} />
									 %
								</div>
								<div className="col-md-3">
									{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"securityAmountBuyerFlag":"securityAmountSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="Deposite" type="number" label="Security amounte (INR)" value={agreementObj.agreementSecurityAmount} />
									 %
								</div>
								<div className="col-md-3">
									{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"ldPercentBuyerFlag":"ldPercentSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="LDPercent" type="number" label="LD (%)" value={agreementObj.agreementLdPercent} />
									 %
								</div>
								<div className="col-md-3">
									{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"ldAppliedAfterDaysBuyerFlag":"ldAppliedAfterDaysSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="LDDays" type="number" label="LD duration (in days)" value={agreementObj.agreementLdAppliedAfterDays} />
									 Days
								</div>
								<div className="col-md-3">
									{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"completionInDaysBuyerFlag":"completionInDaysSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="NumberOfDays" type="number" label="Agreement duration" value={agreementObj.agreementCompletionInDays} />
									 Days
								</div>
								<div className="col-md-3">
									{( IsAgreementFieldChanged(Number(UserProfile.getUserId())===agreementObj.sellerId?"autoGenInvoiceBuyerFlag":"autoGenInvoiceSellerFlag"))
                              		?<span style={{color:'red',fontSize:8}}> Edited</span>:<></>}
									<InputFieldBlank name="AutoGen" type="checkbox" label="Auto generate invoices" value={agreementObj.autoGenInvoice} />
									 Days
								</div>
								
								<div className="col-md-12" style={{ textAlign: "right" }}>
								<br/>
								<div>

								</div>
								<div className="row">
									<div className="col-md-3">
										<FormButton onClick={(e)=>{
											e.preventDefault();
											setShowAgreementForm(false);
										}} name="Close"/>
									</div>
									<div className="col-md-3">
										<FormSubmitButton name={"Edit Agreement"} />
									</div>

								</div>
								</div>
							</div>:<div>
								<div className="row">
									<div className="col-md-6"> Your role: {selected}</div>
									<div className="col-md-6"> Other party contact number: {
									selected==="Seller"?agreementObj.buyerPhoneNumber:agreementObj.sellerPhoneNumber} </div>
								</div>
								<div className="row">
									<div className="col-md-6"> Contract name: {agreementObj.contractName}</div>
									<div className="col-md-6"> Description: {agreementObj.contractDescription} </div>
								</div>
								<div className="row">
									<div className="col-md-6"> Advance(%): {agreementObj.agreementAdvancePercent}</div>
									<div className="col-md-6"> Security(INR): {agreementObj.agreementSecurityAmount} </div>
								</div>
								<div className="row">
									<div className="col-md-6"> Liquidity damage (after days): {agreementObj.agreementLdAppliedAfterDays}</div>
									<div className="col-md-6"> Liquidity damage (%): {agreementObj.agreementLdPercent} </div>
								</div>
								<div className="row">
									<div className="col-md-6"> Contract duration (in days): {agreementObj.agreementCompletionInDays}</div>
									<div className="col-md-6"> Auto generate invoice: {agreementObj.autoGenInvoice?"Yes":"No"} </div>
								</div>
								<div className="row">
									<div className="col-md-3">
										<FormButton onClick={(e)=>{
											e.preventDefault();
											setShowAgreementForm(true);
										}} name="Edit general info"/>
									</div>

								</div>
								</div> }
							
						
						</Form>
						</div>	
						
					</div>
					<div className="table">
						<div className="" >
							<Form ref={itemForm} onSubmit={handleSubmitAddItem}>
								<div style={showItemForm===true?{display:'block'}:{display:'none'}}>
									<div className="row">
										<div className="col-md-3">
											<InputFieldBlank name="ItemCode" type="text" label="Code" />
										</div>
										<div className="col-md-3">
											<InputFieldBlank name="ItemTitle" type="text" label="Item Title" />
										</div>
										<div className="col-md-3">
											<InputFieldBlank name="ItemDescription" type="text" label="Description" />
										</div>
										<div className="col-md-3">
											<InputFieldBlank name="Qty" type="number" label="Quantity" />
										</div>
										
									</div>
									<div className="row">
										<div className="col-md-3">
											<InputFieldBlank name="Tax" type="number" label="Tax" />
										</div>
										<div className="col-md-3">
											<InputFieldBlank name="ItemDeliveredInDays" type="number" label="Completion (in days)" />
										</div>
										<div className="col-md-3">
											<InputFieldBlank name="Rate" type="number" label="Rate" />

										</div>
										<div className="col-md-3">
											
											<span className="" style={{ textAlign: 'left' }}>
												<label style={{ fontsize: '20px', color: 'black', fontWeight: '700' }} >Unit</label>
												<select name="UnitId" className="myAginput"
													onChange={(e) => {
														e.preventDefault();
														//setItemRateCurrency(e.target.value);
													}}>
													<option value="-99" selected >-Select-</option>
													{itemUnitOption && itemUnitOption.length > 0 ?
														itemUnitOption.map(x => <option value={x.id} >{x.typeValue}</option>) :
														<></>}
												</select>
											</span>
										</div>
									</div>
								
									<div className="row">
										<div className="offset-md-6 col-md-3" style={{ textAlign: "right" }}>
											<FormButton onClick={(e)=>{
												e.preventDefault();
												setShowItemForm(false);
												resetItemForm();
											}} name="Close"/>
										</div>
										<div className=" col-md-3" style={{ textAlign: "right" }}>
											<FormSubmitButton name={itemId > 0 ? "Edit Item" : "Save New Item"} />
										</div>
									</div>
								</div>

								{showItemForm!==true && <div className="row">
									<div className="col-md-3">
										<FormButton onClick={(e)=>{
											e.preventDefault();
											setShowItemForm(true);
										}} name="Add new item"/>
									</div>
								</div> }
								
							</Form>
						</div>
						<div className="table" style={{ textAlign: "left" }}>
							<h4 style={{ color: "#0F172A" }}>Item List</h4>
							<div className="d-none d-md-block">
								<div className="row tableHeader">
									<div className="col-md-1 ">
										Code
									</div>
									<div className="col-md-1 ">
										Title
									</div>
									<div className="col-md-3 ">
										Description
									</div>
									<div className="col-md-1 ">
										Quantity
									</div>
									<div className="col-md-2 ">
										Rate
									</div>
									<div className="col-md-1 ">
										Tax
									</div>
									<div className="col-md-1 ">
										Delivery
									</div>

									<div className="col-md-2 " style={{ textAlign: "center" }}>
										Actions
									</div>
								</div>
							</div>
							{itemList && itemList.length > 0 ? itemList.map((x,i) => < div className="row tablebox">
								<div className="col-md-1 d-flex align-items-center">
									<span>
										<strong className="d-inline d-md-none">Code: </strong>
										{x.itemHsnSac}</span>
								</div>
								<div className="col-md-1 d-flex align-items-center">
									<span>
										<strong className="d-inline d-md-none">Title: </strong>
										{x.itemTitle}
									</span>
								</div>
								<div className="col-md-3 d-flex align-items-center">
									<span>
										<strong className="d-inline d-md-none">Description: </strong>
										{x.itemDescription}</span>
								</div>
								<div className="col-md-1 d-flex align-items-center">
									<span>
										<strong className="d-inline d-md-none">Quanityt: </strong>
										{x.itemQuantity}</span>
								</div>
								<div className="col-md-2 d-flex align-items-center">
									<span id={"displayRate" + x.id}>
										<span>{x.itemRate} {agreementObj.currency}/{x.unitName}</span>
									</span>
								</div>
								<div className="col-md-1 d-flex align-items-center">
									<span id={"displayTax" + x.id}>
										{x.itemTax}
									</span>
								</div>
								<div className="col-md-1 d-flex align-items-center">
									{x.itemDeliveredInDays}
								</div>
								<div className="col-md-1" style={{ textAlign: "center" }}>
									<span id={"editBtn" + x.id} style={{ display: "inline" }}>
										<FormButton name="Edit" onClick={(e) => { editOrAddRate(e, x,i) }} />
									</span>
								</div>
							</div>) : <>No Item Is Present.</>}

						</div>
					</div>

					<div className="table">
						<Form ref={termForm} onSubmit={handleSubmitAddTerm}>
							<div className="" style={showTermForm===true?{display:'block'}:{display:'none'}}>

								<div id="SingleTerm" className="tab-content active">
									<div className="row">
										<div className="col-md-5">
											<InputField name="TermTitle" type="text" label="Term Title" value={termTitle} />
										</div>
										<div className="col-md-5">
											<label>Term Text</label>
											<textarea name="TermTxt" rows="4" cols="90">
												{termText}
											</textarea>
											{/*<InputField name="" type="text" label="" value={} />*/}
										</div>
									</div>
									<div className="row" style={{ textAlign: "left", paddingTop: '20px' }}>
										<div className="col-md-12">
											<label style={{ fontsize: '20px', color: 'black', fontWeight: '700', paddingLeft: '18px' }} >Attachments</label>
											<AddAttachment fileLinkList={termAttachments} setFileLinkList={setTermAttachments} />
										</div>
									</div>
									<div className="row">
										<div className="offset-md-4 col-md-4">
											<FormButton onClick={(e)=>{
												e.preventDefault();
												setShowTermForm(false);}} name="Close"/>
										</div>
										<div className="col-md-4" style={{ textAlign: "right" }}>
											<FormSubmitButton name={termId > 0 ? "Edit Term" : "Save New Term"} />
										</div>
									</div>
								</div>

							</div>
							{showTermForm!==true && <div className="row">
								<div className="col-md-3">
									<FormButton onClick={(e)=>{
									e.preventDefault();
									setShowTermForm(true);}} name="Add new term"/>
								</div>
							
							</div>}
							
						</Form>
						<div className="table" style={{ textAlign: "left" }}>
							
							<div className="d-none d-md-block">
								<div className="row tableHeader">
									<div className="col-md-2 ">
										Title
									</div>
									<div className="col-md-6 ">
										Description
									</div>
									<div className="col-md-2 ">
										Attachments
									</div>

									<div className="col-md-2 " style={{ textAlign: "center" }}>
										Actions
									</div>
								</div>
							</div>
							<h4 style={{ color: "#0F172A" }}>Term List</h4>
							{termList && termList.length > 0 ? termList.map((x,i) => < div className="row tablebox">
								<div className="col-md-2 d-flex align-items-center">
									<span>
										<strong className="d-inline d-md-none">Title: </strong>
										{x.termTitle}
									</span>
								</div>
								<div className="col-md-6 d-flex align-items-center">
									<span>
										<strong className="d-inline d-md-none">Description: </strong>
										{x.termTxt}</span>
								</div>
								<div className="col-md-2 d-flex align-items-center">
									<span>
										<strong className="d-inline d-md-none">Attachments: </strong>
										{x.attachments ? x.attachments.map((i) => < div className="col-md-12" style={{ marginBottom: "2px" }}>
											<a href={i.link} target={"new"}>
												<img src={i.link} width={50} height={50} />
											</a>
										</div>) : <span style={{ fontsize: "70%" }}>No Attachments</span>}
									</span>
								</div>
								<div className="col-md-2" style={{ textAlign: "center" }}>
									<span style={{}}>
										<FormButton name="Edit" onClick={(e) => { editTerms(e, x,i); }} />
										<span className="removeLink" onClick={(e) => {
											e.preventDefault();
											setDeleteMsg("Are you sure you want to delete the term ?");
											setDeleteData("api/Business/DeleteAgreementTerm?termId=" + x.id);
										}}> Remove </span>
									</span>
									<span style={{ display: UserProfile.getUserId() === agreementObj.sellerId? "inline" : "none" }}>
										<FormButton name="Add Remark" onClick={(e) => { editTerms(e, x,i); }} />
									</span>
									{/*<FormButton name="Remove"  />*/}
								</div>
							</div>) : <>No Item Is Present.</>}
							
						</div>
					</div>
				</div>
				: <>Loading Data</>}

		</div>
	</>);
};
export default DraftContract;